import { v4 as uuidv4 } from 'uuid';
import { generateSignature } from 'utils/generateSignature';

export const SOURCE = 'eraspace';
export const MYUUID = uuidv4();
export const EPOCH = Math.floor(Date.now() / 1000);
export const SIGNATURE = generateSignature(MYUUID, SOURCE, EPOCH);
export const AUDIENCE_COUNT_PERCENTAGE = 100;
export const AUDIENCE_COUNT = 20000000;
